/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsNotification
 */
export interface SharedserviceMelcoModelsNotification {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsNotification
     */
    event_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsNotification
     */
    desc?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsNotification
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsNotification
     */
    message?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsNotification
     */
    created_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsNotification
     */
    completed_on?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsNotification
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsNotification
     */
    source_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsNotification
     */
    id?: string | null;
}

export function SharedserviceMelcoModelsNotificationFromJSON(json: any): SharedserviceMelcoModelsNotification {
    return SharedserviceMelcoModelsNotificationFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_type': !exists(json, 'event_type') ? undefined : json['event_type'],
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'created_on': !exists(json, 'created_on') ? undefined : (new Date(json['created_on'])),
        'completed_on': !exists(json, 'completed_on') ? undefined : (json['completed_on'] === null ? null : new Date(json['completed_on'])),
        'source': !exists(json, 'source') ? undefined : json['source'],
        'source_id': !exists(json, 'source_id') ? undefined : json['source_id'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function SharedserviceMelcoModelsNotificationToJSON(value?: SharedserviceMelcoModelsNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_type': value.event_type,
        'desc': value.desc,
        'status': value.status,
        'message': value.message,
        'created_on': value.created_on === undefined ? undefined : (value.created_on.toISOString()),
        'completed_on': value.completed_on === undefined ? undefined : (value.completed_on === null ? null : value.completed_on.toISOString()),
        'source': value.source,
        'source_id': value.source_id,
        'id': value.id,
    };
}


